<template>
  <div>
    <el-card class="p-t-lg m-b">
      <base-form
        v-model="baseInfo"
        :options="options"
        labelWidth="100px"
        ref="baseForm"
        @input="handleChangeBaseData"
      ></base-form>
    </el-card>
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('businessOrder.add.relatedPurchase') }}</div
          >
        </template>
        <div class="collapse-content">
          <related-info
            type="purchase"
            ref="relatedPurchase"
            :defaultData="baseDefault.procureList || []"
            :departmentCode="baseInfo.businessDepartmentCode"
          ></related-info>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('businessOrder.add.relatedSales') }}</div
          >
        </template>
        <div class="collapse-content">
          <related-info
            type="sales"
            ref="relatedSales"
            :defaultData="baseDefault.saleList || []"
            :departmentCode="baseInfo.businessDepartmentCode"
          ></related-info>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('businessOrder.add.attachmentList') }}</div
          >
        </template>
        <div class="collapse-content">
          <upload
            v-bind:isShow="isShow"
            @upload="handleUpload"
            :tableData="baseDefault.attachmentList || []"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--TODO 根据不同状态展示不同按钮-->
      <el-button
        type="primary"
        v-hasPermi="['2021042916073985600']"
        :loading="load"
        @click="handleSave"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        type="primary"
        v-hasPermi="['2021042916082578196']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.print') }}</el-button
      >
      <!--TODO sxp 添加 TAPD ID1001044 -->
      <el-button
        v-hasPermi="['2021042916080449239']"
        v-if="this.$route.name == 'businessOrderDetail'"
        type="primary"
        :loading="load"
        class="fixed-bottom-btn"
        @click="handleDel()"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <!-- =========================== -->
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';
  import upload from '@/components/upload';
  import relatedInfo from './components/related-info';
  import API from '@/api/purchaseSalesCenter/businessOrder.js';
  // sxp 添加 TAPD ID1001044&&ID1001223
  import BASE_API from '@/api/dataBase';
  import { dateFormatter } from '@/common/js/util';
  export default {
    components: {
      upload,
      relatedInfo,
      baseForm,
    },
    data() {
      return {
        activeNames: ['1', '2', '3'],
        isShow: true,
        load: false,
        baseInfo: {
          // sxp 添加 TAPD ID1001044
          orderNo: null, // 业务订单号
          supplierNo: null, // 供应链主体
          supplierName: null, // 供应链名称
          businessDepartmentCode: null, // 业务部门
          businessDepartmentName: '', // 业务部门名称
          createBy: null, // 创建人
          gmtCreate: dateFormatter(new Date()), // 创建时间
          remark: null, // 备注
          // =======================
        },
        uploadTableData: [],
        baseDefault: {
          procureList: [],
          saleList: [],
          attachmentList: [],
        },
        departmentList: [], // 部门 sxp 添加 TAPD ID1001044
        personList: [], // 人员 sxp 添加 TAPD ID1001223
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      options() {
        return [
          {
            type: 'input',
            prop: 'orderNo',
            label: this.$t('businessOrder.list.orderNo'),
            disabled: true,
          },
          // sxp 添加 TAPD ID1001223
          {
            // 业务部门
            type: 'select',
            label: this.$t('businessOrder.list.businessDepartmentCode'),
            prop: 'businessDepartmentCode',
            options: this.departmentList,
            filterable: true,
            required: true,
          },
          {
            // 供应链主体
            type: 'searchTable',
            prop: 'supplierName',
            searchType: 'supplychain',
            isMultiple: true,
            label: this.$t('businessOrder.list.supplierName'),
            required: this.baseInfo.businessDepartmentName.indexOf('粮化') != -1,
            currentValue: this.baseInfo.supplierName,
          },
          {
            // 创建人
            type: 'select',
            label: this.$t('businessOrder.list.createBy'),
            prop: 'createBy',
            options: this.personList,
            disabled: true,
          },
          {
            // 创建时间
            type: 'date',
            label: this.$t('businessOrder.list.gmtCreate'),
            prop: 'gmtCreate',
            disabled: true,
          },
          {
            // 备注
            type: 'textarea',
            label: this.$t('businessOrder.list.remark'),
            prop: 'remark',
            clearable: true,
            span: 20,
            maxlength: 1000,
          },
          // ============================
        ];
      },
    },
    mounted() {
      this.getDetail();
      this.getDepartment();
      this.getPerson();
      if (this.$route.name.indexOf('Add') != -1) {
        this.baseInfo.createBy = this.userInfo.userCode;
      }
    },
    methods: {
      getDetail() {
        const orderNo = this.$route.query.orderNo;
        if (orderNo) {
          this.$axios.get(API.GET_ORDER + orderNo).then((res) => {
            if (res.data.code == 0) {
              this.baseDefault = Object.assign({}, res.data.data);
              Object.keys(this.baseInfo).map((item) => {
                return (this.baseInfo[item] = res.data.data[item]);
              });
              this.uploadTableData = this.baseDefault.attachmentList || [];
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      handleUpload(uploadTableData) {
        this.uploadTableData = uploadTableData;
      },
      async handleSave() {
        // const baseInfo = await this.$refs.baseForm.handleSubmit();
        this.load = true;
        // const userInfo = this.userInfo;
        const purchaseList = this.$refs.relatedPurchase.getValues();
        const salesList = this.$refs.relatedSales.getValues();
        const attachment = this.uploadTableData.map((item, index) => {
          const result = Object.assign(
            {},
            {
              sortNo: index + 1,
            },
            item
          );
          return result;
        });
        const salesId = [].concat(purchaseList, salesList).map((item) => {
          return item.associationOrderNo;
        });
        const purchaseQuantity = this.$refs.relatedPurchase.dataNumber;
        const salesQuantity = this.$refs.relatedSales.dataNumber;
        let params = Object.assign(
          {
            purchaseQuantity: purchaseQuantity,
            salesQuantity: salesQuantity,
            salesId,
          },
          this.baseInfo,
          {
            businessOrderAssociationList: [].concat(purchaseList, salesList),
            attachmentList: attachment,
          }
        );
        params.purchaseQuantity = purchaseQuantity || 0;
        params.salesQuantity = salesQuantity || 0;
        params = this.$baseRequest.assignObj(params);
        this.$axios
          .post(API.SAVE_ORDER, params)
          .then((res) => {
            this.load = false;
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              if (this.$route.name == 'businessOrderAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getDetail();
              }
              // this.toList();
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      // TODO sxp 添加 TAPD ID1001044
      handleDel() {
        // 删除
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios
              .post(API.DELETE_ORDER, { orderNos: [this.$route.query.orderNo] })
              .then((res) => {
                if (0 == res.data.code) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  this.toList();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      async getDepartment() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        let res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        if (res.data.code == 0) {
          this.departmentList = res.data.data.personDepartmentInfo.map((item) => {
            return {
              value: item.personDepartmentCode,
              label: item.personDepartmentName,
            };
          });
        }
      },
      async getPerson() {
        // 制单人
        let res = await this.$baseRequest.getPerson();
        if (res) {
          this.personList = res.map((item) => {
            return {
              value: item.id + '',
              label: item.personName,
            };
          });
        }
      },
      handleChangeBaseData(value, prop) {
        if (prop == 'supplierName') {
          // 供应链主体
          this.supplierChange(value.supplierName);
        } else if (prop == 'businessDepartmentCode') {
          // 业务部门
          this.departmentChange(value.businessDepartmentCode);
        }
      },
      supplierChange(val) {
        // 供应链主体
        if (val && val.length > 0) {
          this.baseInfo.supplierNo = val[0].supplierCode;
          this.baseInfo.supplierName = val[0].supplierName;
        } else {
          this.baseInfo.supplierNo = null;
          this.baseInfo.supplierName = null;
        }
      },
      departmentChange(val) {
        // 部门
        this.baseInfo.businessDepartmentName = val
          ? this.departmentList.find((item) => item.value == val).label
          : null;
        this.$refs.relatedPurchase.clearData();
        this.$refs.relatedSales.clearData();
      },
      // ============================
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/businessOrder/add',
            name: 'businessOrderAdd',
            meta: {
              keepAlive: true,
              title: '新建业务订单关联',
            },
          },
          toPath: {
            path: '/businessOrder/detail',
            name: 'businessOrderDetail',
            meta: {
              keepAlive: false,
              title: '业务订单详情',
            },
            query: value.orderNo ? { orderNo: value.orderNo } : {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 返回列表页
      toList() {
        const name = this.$route.name;
        let path = {
          fromPath: {
            path: name === 'businessOrderAdd' ? '/businessOrder/add' : '/businessOrder/detail',
            name: name === 'businessOrderAdd' ? 'businessOrderAdd' : 'businessOrderDetail',
            meta: {
              keepAlive: true,
              title: name === 'businessOrderAdd' ? '新建业务订单关联' : '业务订单详情',
            },
          },
          toPath: {
            path: '/businessOrder/list',
            name: 'businessOrderList',
            meta: {
              keepAlive: false,
              title: '业务订单列表',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .collapse-main-content {
    .collapse-content {
      padding-top: 15px;
    }
  }
</style>
